module.exports = __webpack_public_path__ + "img/shop-feature-design.4102e6c5.png";